type Props = {
	className?: string
}

// Circled question mark in the quotation editor's header — opens the help menu (Share feedback /
// Keyboard shortcuts, REQ-359). Drawn on the same 28×28 box and stroke weight as SettingsIcon so the
// two sit together in the header's right group.
export const HelpIcon = ({ className }: Props) => {
	return (
		<svg
			className={className}
			data-testid="helpIcon"
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="28" height="28" rx="6" fill="white" />
			<path
				d="M14 20.6668C17.6819 20.6668 20.6667 17.682 20.6667 14.0002C20.6667 10.3183 17.6819 7.3335 14 7.3335C10.3181 7.3335 7.33333 10.3183 7.33333 14.0002C7.33333 17.682 10.3181 20.6668 14 20.6668Z"
				stroke="#0A0A0A"
				strokeWidth="0.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.06 11.9998C12.2168 11.5541 12.5262 11.1782 12.9335 10.9387C13.3409 10.6992 13.8199 10.6117 14.2857 10.6918C14.7515 10.7719 15.1739 11.0144 15.4782 11.3762C15.7826 11.7379 15.9493 12.1955 15.9487 12.6681C15.9487 13.9998 13.9487 14.6665 13.9487 14.6665V15.3331"
				stroke="#0A0A0A"
				strokeWidth="0.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M14 17.3335H14.0067" stroke="#0A0A0A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	)
}
